import Header from "./Header";
import Footer from "./Footer";
import { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import translatedHeading from "../utils/util";
import Event from "./Event";
import "../styles/App.css";


const Events = () => {
  const navigate = useNavigate();
  const [selectedEvent, setSelectedEvent] = useState({
    value: "holi",
    label: translatedHeading("Holi"),
  });
  const [event, setEvent] = useState([]);
  const eventOptions = [
    { value: "holi", label: translatedHeading("Holi") },
    { value: "padyatra", label: translatedHeading("Shri Paramhans Dayal Smriti Pad Yatra") },
    { value: "guru_purnima", label: translatedHeading("Guru Purnima") }
  ];
  const customStyles = {
  option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'lightgray' : 'white',
      color:  'black',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: 'black',
      },
    }),
  };

  const handleChange = (e) => {
    const selectedEvent = e.value;
    if (selectedEvent) {
      navigate(`/events/${selectedEvent}`);
    }
    setSelectedEvent(e);
    setEvent([]);
  };

  
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://brahmavidyalayaashram.in/server/api.php?endpoint=/events/${selectedEvent.value}`
        );
       
        if (
          isMounted &&
          response &&
          response.data &&
          Array.isArray(response.data)
        ) {
            setEvent(response.data);
        }
      } catch (error) {
        console.log("API fetch error:", error);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [selectedEvent]);

  return (
    <>
      <Header />
      <div className="page-header">{translatedHeading("Events")}</div>
      <div className="events">
        <div className="events-dropdowns">
          {translatedHeading("Select event")}
          <Select
            placeholder="Select event"
            value={selectedEvent}
            options={eventOptions}
            onChange={handleChange}
            id="eventSelected"
             styles={customStyles}
          />
        </div>
      </div>
      {event.length === 0 && <div className="loader"></div>}
      <div className="events-cards">
      
      {event && event.map((item) => {
        return <Event event = {item} />
      })}
      </div>
      <Footer />
    </>
  );
};
export default Events;
